// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import SpotlightTransition from '@atlaskit/onboarding/spotlight-transition';
import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';
import { useState } from 'react';

import { FilterSpotlight } from './FilterSpotlight';

import { MoreActionsSpotlight } from './MoreActionsSpotlight';

import { type JSX } from 'react/jsx-runtime';

export const HighImpactSpotlightTour = ({
	onDismiss,
}: {
	onDismiss: (isTourCompleted?: boolean) => void;
}): JSX.Element | null => {
	const { onStepChanged } = usePostOfficeUserInteractions();
	const [activeSpotlight, setActiveSpotlight] = useState<null | number>(0);

	const next = () => {
		setActiveSpotlight((activeSpotlight || 0) + 1);
		void onStepChanged({
			interactionIdentifier: 'exploreActions',
			direction: 'next',
			fromStep: 1,
			toStep: 2,
		});
	};

	const endTour = (isTourCompleted = false) => {
		setActiveSpotlight(null);
		onDismiss(isTourCompleted);
	};

	const renderActiveSpotlight = () => {
		const spotlights = [
			<FilterSpotlight key="filter-spotlight" onNext={next} onDismiss={endTour} />,
			<MoreActionsSpotlight key="more-actions-spotlight" onFinish={endTour} />,
		];

		if (activeSpotlight === null) {
			return null;
		}

		return spotlights[activeSpotlight];
	};

	if (activeSpotlight === null) {
		return null;
	}

	return <SpotlightTransition>{renderActiveSpotlight()}</SpotlightTransition>;
};
